import { useMemo } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { usePreferences } from '../preferences/PreferencesProvider';
import { NAVIGATION, type NavDomain } from './registry';

/**
 * The navigation a specific user sees right now: the registry filtered by RBAC
 * permission and by Basic/Advanced mode, with empty domains dropped so no group
 * ever renders without a destination. Ordering is stable by domain `order`.
 */
export function useNavigation(): NavDomain[] {
  const { can } = useAuth();
  const { mode } = usePreferences();

  return useMemo(
    () =>
      NAVIGATION.map((domain) => ({
        ...domain,
        items: domain.items.filter((item) => {
          if (item.advanced && mode !== 'advanced') return false;
          if (item.requiredPermissions && !item.requiredPermissions.some((p) => can(p))) {
            return false;
          }
          return true;
        }),
      }))
        .filter((domain) => domain.items.length > 0)
        .sort((a, b) => a.order - b.order),
    [can, mode],
  );
}
